import "./VerifyTradeListing.css";
import { useEffect } from "react";
import TradeListingGrowing from "./TradeListingGrowing";
import TradeListingStats from "./TradeListingStats";
import TradeListingTable from "./TradeListingTable";
import TradeCalender from "./TradeCalender";
import { useSelector } from "react-redux";
import DashboardMarketSelectBar from "../../sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketSelectBar";

const VerifyTradeListing = () => {
  const { user } = useSelector((state) => state.user);
  // const renderTradeCalender = user.role === "leader" && user.leaderCommunity;
  const { currentTab } = useSelector((state) => state.links);

  useEffect(() => {
    let element = null;
    if (currentTab === "verifiedTradeHistory")
      element = document.getElementById("verifiedTradeHistory");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  }, [currentTab]);

  return (
    <div className="row justify-content-between verifyTradeListingPage">
      <div className={`col-lg-12 flex-column leftContent p-0`}>
        <DashboardMarketSelectBar />
        <TradeListingGrowing />
        <TradeListingStats renderTradeCalender={false} />
        <TradeCalender />
        <TradeListingTable />
      </div>
    </div>
  );
};

export default VerifyTradeListing;
